import { useEffect, type ReactNode } from 'react';
import { NAVBAR_HEIGHT_PX } from '@/constants/layoutHeaderInset';
import type { NavMegaMenuId } from './navMenuConfig';

type NavMegaPanelProps = {
  id: string;
  variant: NavMegaMenuId;
  isOpen: boolean;
  onClose: () => void;
  onHoverEnter?: () => void;
  onHoverLeave?: () => void;
  children: ReactNode;
};

export default function NavMegaPanel({
  id,
  variant,
  isOpen,
  onClose,
  onHoverEnter,
  onHoverLeave,
  children,
}: NavMegaPanelProps) {
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div id={id} className="nav-mega-panel" role="region" style={{ top: NAVBAR_HEIGHT_PX }}>
      <div
        className={`nav-mega-panel__card nav-mega-panel__card--${variant}`}
        onMouseEnter={onHoverEnter}
        onMouseLeave={onHoverLeave}
      >
        {children}
      </div>
    </div>
  );
}
